'use strict';

var GridToolbarSystemConfigurationAdvancedModalDirective = function GridToolbarSystemConfigurationAdvancedModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-system-configuration-advanced-modal.html'),
    controller: 'GridToolbarSystemConfigurationAdvancedModalController'
  };
};
GridToolbarSystemConfigurationAdvancedModalDirective.$inject = [];
module.exports = GridToolbarSystemConfigurationAdvancedModalDirective;